import { ServicesWrapper } from '../graphProduct';

export function getProductType(
  services: Partial<ServicesWrapper>,
  separator = '_',
  inUpperCase = true
) {
  const types: string[] = [];

  if (services.networkInformation) {
    types.push('internet');
  }
  if (services.televisionInfo) {
    types.push('television');
  }
  if (services.callInfo) {
    types.push('call');
  }

  return inUpperCase
    ? types.map((type) => type.toUpperCase()).join(separator)
    : types.join(separator);
}
